import React, { FC, useEffect, useState } from "react";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Calendar from "react-calendar";
import ClickOutsideDetector from "../click-outside-detector";

interface MonthYearInputProps {
  date: Date | null;
  disabled?: boolean;
  required?: boolean;
  minDate?: Date;
  maxDate?: Date;
  positionAbsolute?: boolean;
  onChange: (value: Date | null) => void;
  placeholder?: string;
}

const MonthYearInput: FC<MonthYearInputProps> = ({
  date,
  disabled = false,
  required = false,
  minDate,
  maxDate,
  positionAbsolute = true,
  onChange,
  placeholder,
}) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(date);

  useEffect(() => {
    if (date !== selectedDate) {
      setSelectedDate(date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  const handleInputClick = () => {
    if (disabled) return;
    setShowCalendar(true);
  };

  const handleDateSelection = (value: Date) => {
    setSelectedDate(value);
    setShowCalendar(false);
    onChange(value);
  };

  const formatMonthYear = (date: Date | null) => {
    if (!date) return "";
    return new Intl.DateTimeFormat("th-TH", {
      year: "numeric",
      month: "long",
    }).format(date);
  };

  const onClickOutsideCalendar = () => {
    setShowCalendar(false);
  };

  return (
    <div className="form-group">
      <span className="form-control-icon me-1">
        <FontAwesomeIcon icon={faCalendar} />
      </span>
      <input
        type="text"
        className="form-control form-date-control"
        placeholder={placeholder || ""}
        required={required}
        value={formatMonthYear(selectedDate)}
        disabled={disabled}
        onChange={() => {}}
        onClick={handleInputClick}
      />
      {showCalendar && (
        <ClickOutsideDetector onClickOutside={onClickOutsideCalendar}>
          <div
            className={`${
              positionAbsolute ? "position-absolute calendar-index" : ""
            }`}
          >
            <Calendar
              locale="th-US"
              value={selectedDate}
              minDate={minDate}
              maxDate={maxDate}
              onChange={(value: any) => handleDateSelection(value as Date)}
              view="year"
              maxDetail="year"
            />
          </div>
        </ClickOutsideDetector>
      )}
    </div>
  );
};

export default MonthYearInput;
